import { getAnalyticsUrl, sanitizeTextForAnalytics } from "@/utils/helper"

export const callOverlayEventInfoAnalytics = (
  pdpUrl = "",
  productEventInfo = "",
  productInfo = {},
  data = {}
) => {
  const overlayEventInfo = {
    clickInternalLinks: "true",
    eventAction: "cart overlay:product navigation",
    eventMsg: "n/a",
    eventName: "cart overlay:product navigation",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: sanitizeTextForAnalytics(data.name),
    internalLinkPosition: "cart overlay",
    internalLinkType: "cart overlay:navigation",
    internalLinkURL: getAnalyticsUrl(pdpUrl),
    internalLinkZoneName: "cart:overlay",
  }
  if (window.adobeDataLayer || productEventInfo) {
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    const eventInfo = productEventInfo
      ? JSON.parse(productEventInfo)
      : overlayEventInfo
    eventInfo.internalLinkURL = getAnalyticsUrl(pdpUrl)
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      productInfo,
      page,
    })
  }
}

export const addRemoveProductFromCartPreviewAnalytics = (action, data) => {
  const eventInfo = {
    eventAction: "cart preview:cart update:remove",
    eventName: "cart preview:cart update:remove",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "cart update",
    internalLinkPosition: "cart",
    internalLinkType: "cart:removal",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  sessionStorage.setItem("cartLanding", eventInfo.searchCount)
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}

  const removedItem = page?.cart?.item?.find(
    item => item.productInfo.productID === data.sku
  )
  const updatedPage = page?.cart?.item?.filter(
    item => item?.productInfo?.productID !== data.sku
  )

  if (page && page.cart && page.cart.item) {
    page.cart.item = updatedPage
  }

  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: removedItem?.productInfo,
  })
}

export const viewCartPreviewAnalytics = (action, linkUrl) => {
  const eventInfo = {
    eventAction: "cart:preview:view cart",
    eventName: "cart:preview:view cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "view cart",
    internalLinkPosition: "cart preview",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: getAnalyticsUrl(linkUrl),
    clickInternalLinks: "true",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
  })
}

export const viewCheckoutPreviewAnalytics = (action, linkUrl) => {
  const eventInfo = {
    eventAction: "cart:preview:checkout",
    eventName: "cart:preview:checkout",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "checkout",
    internalLinkPosition: "cart preview",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: getAnalyticsUrl(linkUrl),
    clickInternalLinks: "true",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
  })
}

export const continueShoppingPreviewAnalytics = (action) => {
  const eventInfo = {
    eventAction: "cart:preview:continue shopping",
    eventName: "cart:preview:continue shopping",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue shopping",
    internalLinkPosition: "cart preview",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:preview",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
  })
}

export const getCustomAnalyticsData = (
  cartAnalytics = {},
  cartID = "",
  subtotal = ""
) => {
  const { item } = cartAnalytics
  return JSON.stringify({
    cart: { cartID: cartID, price: subtotal, items: item },
  })
}
